import * as React from "react"
import { IconNamesProps } from "./Icon"

function list(props: IconNamesProps) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.357 4.024c0-.645.522-1.167 1.167-1.167h.524c.644 0 1.166.522 1.166 1.167v.524c0 .644-.522 1.166-1.166 1.166h-.524a1.167 1.167 0 01-1.167-1.166v-.524zm5.714 0c0-.645.523-1.167 1.167-1.167h6.238c.645 0 1.167.522 1.167 1.167v.524c0 .644-.523 1.166-1.167 1.166h-6.238a1.167 1.167 0 01-1.167-1.166v-.524zm0 5.714c0-.644.523-1.167 1.167-1.167h6.238c.645 0 1.167.523 1.167 1.167v.524c0 .644-.523 1.167-1.167 1.167h-6.238a1.167 1.167 0 01-1.167-1.167v-.524zm8.572 5.714c0-.644-.523-1.166-1.167-1.166h-6.238c-.644 0-1.167.522-1.167 1.166v.524c0 .644.523 1.167 1.167 1.167h6.238c.645 0 1.167-.523 1.167-1.167v-.524zM6.214 9.738c0-.644-.522-1.167-1.166-1.167h-.524c-.645 0-1.167.523-1.167 1.167v.524c0 .644.522 1.167 1.167 1.167h.524c.644 0 1.166-.523 1.166-1.167v-.524zm-2.857 5.714c0-.644.522-1.166 1.167-1.166h.524c.644 0 1.166.522 1.166 1.166v.524c0 .644-.522 1.167-1.166 1.167h-.524a1.167 1.167 0 01-1.167-1.167v-.524zM20.5 18.833c0 .645-.522 1.167-1.167 1.167H1.667A1.167 1.167 0 01.5 18.833V1.167C.5.522 1.022 0 1.667 0h17.666c.645 0 1.167.522 1.167 1.167v17.666z"
                fill={props.color || "#000"}
            />
        </svg>
    )
}

export default list
